// ============================================
// タブ切り替え（フェードアニメーション付き）
// ============================================

/**
 * タブ切り替えを初期化
 * 同ページ内に複数の tablist があっても、各グループ内で独立して動作する
 */
export function initTab() {
	const tablists = document.querySelectorAll('[role="tablist"]');
	if (!tablists.length) return;

	tablists.forEach((tablist) => {
		const tabs = [...tablist.querySelectorAll('[role="tab"]')];
		if (!tabs.length) return;

		/* 変更: アニメーション状態をグループごとに管理 */
		let currentAnimation = null;

		/* タブクリック */
		tabs.forEach((tab) => {
			tab.addEventListener('click', (e) => {
				e.preventDefault();
				handleSwitch(tab);
			});
		});

		/* キーボードナビゲーション（矢印キー / Home / End） */
		tablist.addEventListener('keydown', (e) => {
			const currentTab = e.target.closest('[role="tab"]');
			if (!currentTab) return;

			const currentIndex = tabs.indexOf(currentTab);
			let nextIndex = -1;

			switch (e.key) {
				case 'ArrowRight':
				case 'ArrowDown':
					nextIndex = (currentIndex + 1) % tabs.length;
					break;
				case 'ArrowLeft':
				case 'ArrowUp':
					nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
					break;
				case 'Home':
					nextIndex = 0;
					break;
				case 'End':
					nextIndex = tabs.length - 1;
					break;
				default:
					return;
			}

			e.preventDefault();
			handleSwitch(tabs[nextIndex]);
			tabs[nextIndex].focus();
		});

		/**
		 * タブ切り替え処理（アニメーション管理付き）
		 * @param {HTMLElement} activeTab - 選択するタブ要素
		 */
		function handleSwitch(activeTab) {
			if (activeTab.getAttribute('aria-selected') === 'true') return;

			/* 進行中のアニメーションがあれば即完了させる */
			if (currentAnimation) {
				finishAnimation(currentAnimation);
				currentAnimation = null;
			}

			/* 現在のアクティブパネルを取得 */
			const prevTab = tabs.find((t) => t.getAttribute('aria-selected') === 'true');
			const prevPanelId = prevTab ? prevTab.getAttribute('aria-controls') : null;
			const prevPanel = prevPanelId ? document.getElementById(prevPanelId) : null;

			const nextPanelId = activeTab.getAttribute('aria-controls');
			const nextPanel = nextPanelId ? document.getElementById(nextPanelId) : null;

			/* タブの状態を即座に更新 */
			tabs.forEach((tab) => {
				if (tab === activeTab) {
					tab.setAttribute('aria-selected', 'true');
					tab.setAttribute('tabindex', '0');
				} else {
					tab.setAttribute('aria-selected', 'false');
					tab.setAttribute('tabindex', '-1');
				}
			});

			if (!nextPanel) return;

			if (prevPanel && prevPanel !== nextPanel) {
				/* フェードアウト → フェードイン */
				const anim = { prevPanel, nextPanel, handler: null };
				currentAnimation = anim;

				/* フェードアウト開始 */
				prevPanel.style.opacity = '0';

				anim.handler = (e) => {
					if (e.propertyName !== 'opacity') return;
					prevPanel.removeEventListener('transitionend', anim.handler);

					/* 別のアニメーションに置き換わった場合は中断 */
					if (currentAnimation !== anim) return;

					/* フェードアウト完了 → パネル切り替え */
					prevPanel.style.opacity = '';
					prevPanel.setAttribute('hidden', 'until-found');

					/* フェードイン開始 */
					nextPanel.removeAttribute('hidden');
					nextPanel.style.opacity = '0';

					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							nextPanel.style.opacity = '';
							currentAnimation = null;
						});
					});
				};

				prevPanel.addEventListener('transitionend', anim.handler);
			} else {
				/* prevPanel がない場合はそのまま表示 */
				nextPanel.removeAttribute('hidden');
			}
		}

		/**
		 * 進行中のアニメーションを即座に完了させる（連打対策）
		 * @param {Object} anim - アニメーション状態オブジェクト
		 */
		function finishAnimation(anim) {
			const { prevPanel, nextPanel, handler } = anim;

			if (handler) {
				prevPanel.removeEventListener('transitionend', handler);
			}

			/* 即座に最終状態へ */
			prevPanel.style.opacity = '';
			prevPanel.setAttribute('hidden', 'until-found');
			nextPanel.removeAttribute('hidden');
			nextPanel.style.opacity = '';
		}
	});
}
